<ng-container [formGroup]="formGroup">
  @if (updateRequired) {
    <pdq-banner
      variant="attention"
      [closable]="false"
      bannerTitle="Update required to create coupons"
      content="You've selected the Coupon Offer Type, but your current app permissions do not include the ability to create coupons. Please update your app to enable the new permissions and to access this feature."
      button="Update app"
      variantButton="ghost"
      (onButtonClickEmitter)="onUpdateAppPermissions()">
    </pdq-banner>
  }
  <div class="flex-row">
    <pdq-dropdown
      [formControl]="formGroup.get('settings.couponDetails.couponType')"
      title="Coupon Type"
      [options]="couponTypeOptions"
      optionLabel="label"
      optionValue="value">
    </pdq-dropdown>
    @if (!isMaxxAi) {
      <pdq-input-arrows
        [formControl]="formGroup.get('settings.couponDetails.discountValue')"
        label="Coupon value"
        widthSize="auto"
        precision="2"
        min="1"
        [max]="formGroup.get('settings.couponDetails.couponType').value === CouponType.PERCENTAGE ? 100 : undefined"
        [symbol]="
          formGroup.get('settings.couponDetails.couponType').value === CouponType.PERCENTAGE ? '%' : shopCurrencySymbol
        ">
      </pdq-input-arrows>
    }
  </div>
  <div class="expires-in-field">
    <pdq-input-arrows
      [formControl]="formGroup.get('settings.couponDetails.couponExpiryDays')"
      label="Expires in (days)"
      widthSize="auto"
      min="1"
      [required]="false">
    </pdq-input-arrows>
    <span>Leave blank for no expiration time</span>
  </div>
  @if (!isMaxxAi) {
    <div class="auto-apply-coupon-wrapper">
      <pdq-checkbox
        [formControl]="formGroup.get('settings.couponDetails.autoApplyCoupon')"
        [secondaryLabel]="
          formGroup.get('settings.couponDetails.autoApplyCoupon').value
            ? 'Selecting this option will disable the \'Gift message\' and \'Pop up\' widgets.'
            : ''
        "
        label="Auto-apply coupon if unlocked"
        labelSize="small">
      </pdq-checkbox>
    </div>
  }
  <div class="combines-with-section">
    <label>Combines with</label>
    <pdq-checkbox
      [formControl]="formGroup.get('settings.couponDetails.combinesWithProductDiscounts')"
      label="Product discounts"
      labelSize="small">
    </pdq-checkbox>
    <pdq-checkbox
      [formControl]="formGroup.get('settings.couponDetails.combinesWithOrderDiscounts')"
      label="Order discounts"
      labelSize="small">
    </pdq-checkbox>
    <pdq-checkbox
      [formControl]="formGroup.get('settings.couponDetails.combinesWithShippingDiscounts')"
      label="Shipping discounts"
      labelSize="small">
    </pdq-checkbox>
  </div>

  @if (isMaxxAi && maxxAiGroup) {
    <gift-unlock-guardrails
      [formGroup]="maxxAiGroup"
      [couponType]="formGroup.get('settings.couponDetails.couponType').value"
      [shopCurrencySymbol]="shopCurrencySymbol">
    </gift-unlock-guardrails>
  }

  <pdq-input [formControl]="formGroup.get('giftPopup.title')" label="Pop Up Display Title"> </pdq-input>
  <pdq-input [formControl]="formGroup.get('giftPopup.text')" label="Pop Up Display Subtitle"> </pdq-input>
  <pdq-input
    [formControl]="formGroup.get('giftPopup.actionButtonText')"
    label="Call To Action Button Text"
    [tooltip]="'Applies the coupon to the order'">
  </pdq-input>
  <pdq-input
    [formControl]="formGroup.get('giftPopup.declineButtonText')"
    label="Decline Button Text"
    [tooltip]="'Closes the pop up'">
  </pdq-input>
</ng-container>
